import {
  supportArticlesList,
  supportFeedbackCreate,
  supportSystemStatus,
} from './supportApi';

export const seedSupportArticles = async () => null;

export const fetchSupportArticles = async (firebase) => {
  const data = await supportArticlesList(firebase);
  return data?.items || [];
};

export const submitArticleFeedback = async (firebase, payload) =>
  supportFeedbackCreate(firebase, payload);

export const fetchSystemStatus = async (firebase) =>
  supportSystemStatus(firebase);

export const getSupportArticlesCatalog = () => [];
